import React from "react";
import { Outlet} from "react-router-dom";

export const Services = () => {

  return (
    <div>
        <div className="row g-0 feature-row">
          <Outlet />
        </div>
    </div>
  );
};
